







































import { defineComponent, PropType } from '@vue/composition-api'

// components
import TaskItemTr from './TaskItemTr.vue'
import TableWorDescription from './TableWorkDescription.vue'

// models
import { TaskSheet, TaskSheetItem } from '@/models/taskSheet'

// utils
import { dateLibs } from '@/utils'

export default defineComponent({
  name: 'TaskTableBody',
  components: {
    TaskItemTr,
    TableWorDescription
  },
  props: {
    headers: {
      required: true,
      type: Array as PropType<{ text: string; key: keyof TaskSheetItem }[]>
    },
    items: {
      required: true,
      type: Array as PropType<TaskSheet[]>
    },
    workType: {
      required: true,
      type: Number as PropType<number>
    },
    date: {
      required: true,
      type: String as PropType<string>
    },
    actionForm: {
      type: String
    }
  },
  setup (props) {
    console.log('holiiiis: ' + TaskSheet)
    const isSunday = dateLibs.isSunday(props.date)
    const isHoliday = dateLibs.isHoliday(props.date)
    return {
      isSunday,
      isHoliday
    }
  }
})
